import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

/** MOD chưa phải KTV và chưa được Admin cấp quyền gõ thẳng đường dẫn Báo giá thiết bị. */
const NoAccess = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="Bạn chưa được dùng Báo giá thiết bị"
      subTitle="KTV đã bật ở Hỗ trợ LIVE tự có quyền. Người khác nhờ Admin cấp ở Báo giá thiết bị → Cài đặt → Người được dùng."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Về Tổng quan
        </Button>
      }
    />
  );
};

export default NoAccess;
